import * as React from "react"
const ThumbtackIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M.667 15.984c.176 0 .346-.07.47-.195l4.414-4.413.832.862a3.446 3.446 0 0 0 2.403 1.076c.304 0 .606-.05.893-.152a2.42 2.42 0 0 0 1.623-2.08 5.658 5.658 0 0 0-.148-2.019l-.143-.695a.667.667 0 0 1 .176-.628l1.058-1.059a.227.227 0 0 1 .158-.067.114.114 0 0 1 .11.044 2.051 2.051 0 0 0 2.648.288 2 2 0 0 0 .253-3.044L12.134.62A2.057 2.057 0 0 0 9.507.354a2 2 0 0 0-.253 3.043l.05.05a.205.205 0 0 1 0 .29L8.24 4.804a.667.667 0 0 1-.636.174l-.545-.14a5.755 5.755 0 0 0-2.055-.155 2.575 2.575 0 0 0-2.17 1.724 2.667 2.667 0 0 0 .619 2.8l1.172 1.213-4.429 4.426a.667.667 0 0 0 .472 1.138ZM4.09 6.851a1.237 1.237 0 0 1 1.052-.843 4.47 4.47 0 0 1 1.583.121l.548.14a2.007 2.007 0 0 0 1.908-.523l1.067-1.067a1.54 1.54 0 0 0 0-2.175l-.05-.05a.667.667 0 0 1 .088-1.019.723.723 0 0 1 .905.127l3.282 3.282a.667.667 0 0 1-.09 1.02.723.723 0 0 1-.911-.134 1.475 1.475 0 0 0-1.056-.448 1.6 1.6 0 0 0-1.111.456l-1.058 1.058a2 2 0 0 0-.533 1.866l.146.706a4.43 4.43 0 0 1 .12 1.577 1.104 1.104 0 0 1-.743.963 1.868 1.868 0 0 1-1.9-.6L4.404 8.274a1.351 1.351 0 0 1-.314-1.423Z"
    />
  </svg>
)
export default ThumbtackIcon
